module.exports = __webpack_public_path__ + "aa970a3f1e8c896b7c7a5d436032507d.jpg";